import request from "@/utils/request"
export const homeData = (data) =>
    request({
        url: '/home',
        method: 'get',
        params: data,
        data,
    })
export const wxLogin = (code) =>
    request({
        url: '/user/wx-login',
        method: 'post',
        data:{code},
    })